// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"649496b7","693":"c6043708"}[chunkId] + ".chunk.css";
};